import { Component, OnInit, ViewChild, ViewChildren, QueryList, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';

import { ModalDirective } from 'ngx-bootstrap/modal';
import {
  AudioRecordsService,
  AppConfigurationService,
  APP_CONFIGURATION,
  IAppConfigurationBase,
  VoiceBotsService,
  CallCenterService,
  DEFAULT_AUDIO_RECORD_FILENAME_TEMPLATE,
  AUDIO_RECORD_FILENAME_TEMPLATE_CHIPS,
} from '@libs/portal-common/services';
import { AudioPlayerComponent } from '@libs/portal-common/shared';
import { AppNotificationsService } from '@libs/portal-common/system';
import { HttpClient, HttpResponse } from '@angular/common/http';
import * as moment from 'moment';
import { Observable, Observer } from 'rxjs';

class AudioRecord {
  Id: number;
  CallId: string;
  Caller: string;
  Duration: number;
  EndTime: Date;
  FileName: string;
  FileSize: number;
  StartTime: Date;
  fkIncident: number;
  SessionId: string;

  url: string = null;
}

@Component({
  selector: 'app-audio-records',
  templateUrl: './audio-records.component.html',
  styleUrls: ['./audio-records.component.scss'],
})
export class AudioRecordsComponent implements OnInit {
  @ViewChild('modal', { static: true }) public modal: ModalDirective;
  @ViewChildren(AudioPlayerComponent) players: QueryList<AudioPlayerComponent>;

  incidentId: number;

  audioRecordsList = new Array<AudioRecord>();
  resultObserver: Observer<any>;
  audioRecordFilenameTemplate = '';
  availableRecordChips = AUDIO_RECORD_FILENAME_TEMPLATE_CHIPS;

  constructor(
    private _httpClient: HttpClient,
    private sanitizer: DomSanitizer,
    @Inject(APP_CONFIGURATION) private configuration: AppConfigurationService<IAppConfigurationBase>,
    private audioRecordsService: AudioRecordsService,
    private notifications: AppNotificationsService,
    private voiceBotService: VoiceBotsService,
    private callCenterService: CallCenterService,
  ) {}

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  ngOnInit() {}

  open(incidentId: number): Observable<any> {
    this.incidentId = incidentId;

    this.initAudioRecords();
    this.setAudioRecordFilenameTemplate();

    this.modal.show();
    this.activateModal();
    return new Observable((observer) => (this.resultObserver = observer));
  }

  openVBEventAudio(conferenceId: string) {
    this.audioRecordsList = [];

    this.voiceBotService.getBotEvent(conferenceId).subscribe((response) => {
      if (response.Success) {
        this.audioRecordsList.push(<AudioRecord>{
          url: `${this.configuration.apiBaseUrl}/BotEvent/${response.BotEvent.ConferenceId}/Record`,
          Caller: response.BotEvent.Caller,
          FileName: response.BotEvent.FileName,
        });
      }
    });
    this.activateModal();
  }

  cancel() {
    if (this.players) {
      this.players.forEach((p) => p.pause());
    }

    this.modal.hide();

    if (this.resultObserver) {
      this.resultObserver.next(null);
      this.resultObserver.complete();
      this.resultObserver = null;
    }
  }

  private activateModal() {
    this.modal.show();
    this.modal.onHidden.subscribe(() => {
      this.cancel();
    });
  }

  private initAudioRecords() {
    this.audioRecordsList = [];

    this.audioRecordsService
      .getByIncident(this.incidentId)
      .pipe(
        map((response) => {
          if (response.Success === true) {
            return <AudioRecord>response.AudioRecord;
          } else {
            this.notifications.error(response.Message);
            return null;
          }
        }),
        filter((audioRecord) => audioRecord !== null),
      )
      .subscribe((audioRecord) => {
        this.audioRecordsList.push(audioRecord);
        this.audioRecordsList.forEach((record) => {
          record.url = `${this.configuration.apiBaseUrl}/AudioRecords/Download/${record.Id}`;
        });
      });
  }

  private setAudioRecordFilenameTemplate() {
    this.callCenterService.getCallCenter(1).subscribe((response) => {
      if (!response.Success) {
        this.audioRecordFilenameTemplate = DEFAULT_AUDIO_RECORD_FILENAME_TEMPLATE;
      }
      this.audioRecordFilenameTemplate = response.CallCenter.AudioRecordFilenameTemplate || DEFAULT_AUDIO_RECORD_FILENAME_TEMPLATE;
    });
  }

  downloadFile(record: AudioRecord) {
    this._httpClient
      .get(record.url, {
        observe: 'response',
        responseType: 'blob',
      })
      .subscribe(
        (response: HttpResponse<Blob>) => {
          const body = response.body;
          if (!body) {
            console.error('File is empty');
            return;
          }

          let fileNameToSave = '';
          let originalFilename = record.FileName;

          if (originalFilename) {
            const date = moment(record.StartTime).format('YYYY-MM-DD-HH-mm-ss');
            fileNameToSave = this.audioRecordFilenameTemplate
              .replace(this.availableRecordChips[0], this.incidentId ? this.incidentId.toString() : 'null')
              .replace(this.availableRecordChips[1], record.SessionId ? record.SessionId : 'null')
              .replace(this.availableRecordChips[2], record.Caller ? record.Caller : 'null')
              .replace(this.availableRecordChips[3], date ? date : 'null');
          }

          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(body);
          a.href = objectUrl;
          a.download = fileNameToSave ? fileNameToSave + '.mp3' : originalFilename;

          a.click();

          URL.revokeObjectURL(objectUrl);
        },
        (error) => {
          console.error('Download has been failed: ', error);
        },
      );
  }
}
